module.exports = __webpack_public_path__ + "img/c-06.34003960.jpg";